
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"28","height":"4","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M2 2h24","stroke":"#D2D2D2","stroke-width":"3","fill":"none","fill-rule":"evenodd","stroke-linecap":"square"}})])
      }
    
      }
    